export class SelectProductOptionInModal {
    constructor(optionalOptions = {}) {
        this._optionsListWrap = document.querySelectorAll('.modal-desktop-menu--add-order [data-type="select-product-option"]');

        if (!this._optionsListWrap) {
            this.destructor();
            return true;
        }

        const removeSelectedMarker = (thatList) => {
            if (thatList.querySelector('li.selected')) {
                thatList.querySelector('li.selected').classList.remove('selected');
            }
        }

        let targetDataInput;
        let targetDataText;
        let targetInput;
        let targetText;
        let targetPriceButton;

        this._optionsListWrap.forEach((oneList) => {
            this._optionOne = oneList.querySelectorAll('li')
            if (!this._optionOne) {
                this.destructor();
                return true;
            }

            this._optionOne.forEach((one) => {
                one.addEventListener("click", () => {
                    if (one.classList.contains('selected')) {
                        return false
                    }

                    removeSelectedMarker(oneList)
                    one.classList.add('selected')

                    targetPriceButton = one.closest('.menu-choosing-option--open').querySelector('.menu-choosing-option-open--button .base-button')
                    if (targetPriceButton) {
                        if (one.dataset.price) {
                            if (parseInt(one.dataset.price) === 0) {
                                targetPriceButton.querySelector('span.price').style.display = "none"
                            } else {
                                targetPriceButton.querySelector('span.price').style.display = "inline"
                                targetPriceButton.querySelector('span.price span').innerHTML = one.dataset.price
                            }
                        }
                    }
                })
            })

            targetPriceButton = oneList.closest('.menu-choosing-option--open').querySelector('.menu-choosing-option-open--button .base-button')

            targetPriceButton.addEventListener("click", () => {
                targetDataInput = oneList.dataset.inputTarget
                targetDataText = oneList.dataset.textTarget

                if (targetDataInput) {
                    targetInput = document.querySelector(targetDataInput);

                    if (!targetInput) {
                        return false
                    }

                    targetInput.val = oneList.querySelector('li.selected').dataset.value
                }

                if (targetDataText) {
                    targetText = document.querySelector(targetDataText);
                    if (!targetText) {
                        return false
                    }

                    targetText.classList.add('selected')
                    targetText.innerText = oneList.querySelector('li.selected').dataset.display
                }

                oneList.closest('.menu-choosing-option--open').style.display = "none";

                document.querySelector('body').classList.remove('no-scroll');
            })
        })
    }

    destructor() {
        this._optionsListWrap = null;
        this._optionOne = null;
    }
}

export default new SelectProductOptionInModal();
